import { useCallback } from "react"
import { SupportedTokenName } from "@mezo/api"

import { setLatestTransaction, useDappDispatch } from "#/redux-state"
import { DATABASE_DECIMALS_COUNT } from "#/shared/constants"

const useLatestBridgeTransaction = () => {
  const dispatch = useDappDispatch()

  const setLatestTransactionHandler = useCallback(
    (
      tokenAmount: bigint | null,
      token: SupportedTokenName,
      tokenDecimals: number,
      transactionHash: string,
    ) => {
      const amount = tokenAmount
        ? (
            tokenAmount *
            10n ** BigInt(DATABASE_DECIMALS_COUNT - tokenDecimals)
          ).toString()
        : null

      dispatch(
        setLatestTransaction({
          transactionHash,
          timestamp: Date.now(),
          type: "bridge",
          metadata: {
            amount,
            token,
          },
        }),
      )
    },
    [dispatch],
  )

  return {
    setLatestBridgeTransaction: setLatestTransactionHandler,
  }
}

export default useLatestBridgeTransaction
